'use client';

import { ReactNode, createContext, useState } from 'react';

interface SearchBarProviderProps {
  children: ReactNode;
}

type Dispatch<A> = (value: A) => void;
type SetStateAction<S> = S | ((prevState: S) => S);

export const SearchBarContext = createContext<{
  isSearchBarOpen: boolean;
  setIsSearchBarOpen: Dispatch<SetStateAction<boolean>>;
}>({
  isSearchBarOpen: false,
  setIsSearchBarOpen: () => {},
});

const SearchBarProvider = ({ children }: SearchBarProviderProps) => {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState<boolean>(false);

  return (
    <SearchBarContext.Provider value={{ isSearchBarOpen, setIsSearchBarOpen }}>{children}</SearchBarContext.Provider>
  );
};

export default SearchBarProvider;
